'use client';

import { MultiErrorModal } from '@brahma/components';
const MultiErrorModalWrapper = (props: any) => {
  return <MultiErrorModal {...props} data-sentry-element="MultiErrorModal" data-sentry-component="MultiErrorModalWrapper" data-sentry-source-file="index.tsx" />;
};
export default MultiErrorModalWrapper;